// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AppearanceExample__container-f5f470 {
  border-bottom: 1px solid var(--base-20);
  position: relative;
}

.AppearanceExample__content-e32c7e {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  padding: 16px;
  height: 100%;
  position: relative;
}

.AppearanceExample__message-bubble-ac8f5b {
  border-radius: 16px;
  padding: 10px 12px;
  display: flex;
  flex-direction: column;
}

.AppearanceExample__short-bubble-fff339 {
  flex-direction: row;
  align-items: baseline;
}

.AppearanceExample__message-bubble-ac8f5b.AppearanceExample__left-ac57b9 {
  align-self: flex-start;
  background: var(--incoming-bubble-bg);
  margin-bottom: 8px;
}

.AppearanceExample__message-bubble-ac8f5b.AppearanceExample__right-dad1c8 {
  align-self: flex-end;
  background: var(--outgoing-bubble-bg);
}

.AppearanceExample__message-bubble-ac8f5b.AppearanceExample__right-dad1c8:not(:last-child) {
  margin-bottom: 4px;
  border-bottom-right-radius: 4px;
}

.AppearanceExample__message-bubble-ac8f5b.AppearanceExample__right-dad1c8:last-child {
  border-top-right-radius: 4px;
}

.AppearanceExample__message-reply-c2c20d {
  border-left: 2px solid var(--incoming-bubble-primary);
  margin-top: 4px;
  margin-bottom: 8px;
  padding-inline-start: 8px;
}

.AppearanceExample__reply-name-e5c33c {
  color: var(--incoming-bubble-primary);
  font: var(--font-subtitle-2);
  letter-spacing: var(--font-spacing-subtitle-2);
}

.AppearanceExample__reply-text-d3dc72 {
  color: var(--incoming-bubble-text-secondary);
  font: var(--font-subtitle-4);
  letter-spacing: var(--font-spacing-subtitle-4);
}

.AppearanceExample__message-a7e13b {
  align-items: center;
  display: flex;
  gap: 8px;
  justify-content: space-between;
}

.AppearanceExample__message-text-abbbdf {
  font: var(--font-body-5);
  letter-spacing: var(--font-spacing-body-5);
}

.AppearanceExample__left-ac57b9 .AppearanceExample__message-text-abbbdf {
  color: var(--incoming-bubble-text-primary);
  max-width: 276px;
}

.AppearanceExample__right-dad1c8 .AppearanceExample__message-text-abbbdf {
  color: var(--outgoing-bubble-text);
}

.AppearanceExample__message-status-c37ee6 {
  align-items: center;
  color: var(--base-80);
  font: var(--font-caption-1);
  letter-spacing: var(--font-spacing-caption-1);
  display: flex;
  gap: 8px;
  margin-inline-start: 8px;
}

.AppearanceExample__message-bubble-ac8f5b:not(.AppearanceExample__short-bubble-fff339) .AppearanceExample__message-status-c37ee6 {
  align-self: flex-end;
  margin-top: -16px;
}

.AppearanceExample__left-ac57b9 .AppearanceExample__message-status-c37ee6 {
  color: var(--outgoing-bubble-text_70);
}

.AppearanceExample__right-dad1c8 .AppearanceExample__message-status-c37ee6 {
  color: var(--incoming-bubble-text-secondary);
}

.AppearanceExample__status-icon-e4ad88 {
  fill: var(--outgoing-bubble-primary);
}

.AppearanceExample__audio-message-cc966d {
  display: flex;
  align-items: center;
  gap: 10px;
}

.AppearanceExample__audio-histogram-d22935 {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.AppearanceExample__histogram-image-ce0a85 {
  width: 188px;
  height: 24px;
}

.AppearanceExample__audio-duration-e75613 {
  color: var(--outgoing-bubble-text_70);
  font: var(--font-subtitle-4);
  letter-spacing: var(--font-spacing-subtitle-4);
  margin-top: 2px;
}

.AppearanceExample__play-icon-cd292e {
  --file-ic-primary-color: var(--outgoing-bubble-primary);
  --file-ic-secondary-color: var(--outgoing-bubble-on-primary);
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/components/Appearance/AppearanceExample/AppearanceExample.styles.m.css"],"names":[],"mappings":"AAAA;EACE,uCAAA;EACA,kBAAA;AACF;;AAEA;EACE,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;AACF;;AAEA;EACE,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;AACF;;AAEA;EACE,mBAAA;EACA,qBAAA;AACF;;AAEA;EACE,sBAAA;EACA,qCAAA;EACA,kBAAA;AACF;;AAEA;EACE,oBAAA;EACA,qCAAA;AACF;;AAEA;EACE,kBAAA;EACA,+BAAA;AACF;;AAEA;EACE,4BAAA;AACF;;AAEA;EACE,qDAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;AACF;;AAEA;EACE,qCAAA;EACA,4BAAA;EACA,8CAAA;AACF;;AAEA;EACE,4CAAA;EACA,4BAAA;EACA,8CAAA;AACF;;AAEA;EACE,mBAAA;EACA,aAAA;EACA,QAAA;EACA,8BAAA;AACF;;AAEA;EACE,wBAAA;EACA,0CAAA;AACF;;AAEA;EACE,0CAAA;EACA,gBAAA;AACF;;AAEA;EACE,kCAAA;AACF;;AAEA;EACE,mBAAA;EACA,qBAAA;EACA,2BAAA;EACA,6CAAA;EACA,aAAA;EACA,QAAA;EACA,wBAAA;AACF;;AAEA;EACE,oBAAA;EACA,iBAAA;AACF;;AAEA;EACE,qCAAA;AACF;;AAEA;EACE,4CAAA;AACF;;AAEA;EACE,oCAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,2BAAA;AACF;;AAEA;EACE,YAAA;EACA,YAAA;AACF;;AAEA;EACE,qCAAA;EACA,4BAAA;EACA,8CAAA;EACA,eAAA;AACF;;AAEA;EACE,uDAAA;EACA,4DAAA;AACF","sourcesContent":[".container {\n  border-bottom: 1px solid var(--base-20);\n  position: relative;\n}\n\n.content {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  padding: 16px;\n  height: 100%;\n  position: relative;\n}\n\n.message-bubble {\n  border-radius: 16px;\n  padding: 10px 12px;\n  display: flex;\n  flex-direction: column;\n}\n\n.short-bubble {\n  flex-direction: row;\n  align-items: baseline;\n}\n\n.message-bubble.left {\n  align-self: flex-start;\n  background: var(--incoming-bubble-bg);\n  margin-bottom: 8px;\n}\n\n.message-bubble.right {\n  align-self: flex-end;\n  background: var(--outgoing-bubble-bg);\n}\n\n.message-bubble.right:not(:last-child) {\n  margin-bottom: 4px;\n  border-bottom-right-radius: 4px;\n}\n\n.message-bubble.right:last-child {\n  border-top-right-radius: 4px;\n}\n\n.message-reply {\n  border-left: 2px solid var(--incoming-bubble-primary);\n  margin-top: 4px;\n  margin-bottom: 8px;\n  padding-inline-start: 8px;\n}\n\n.reply-name {\n  color: var(--incoming-bubble-primary);\n  font: var(--font-subtitle-2);\n  letter-spacing: var(--font-spacing-subtitle-2);\n}\n\n.reply-text {\n  color: var(--incoming-bubble-text-secondary);\n  font: var(--font-subtitle-4);\n  letter-spacing: var(--font-spacing-subtitle-4);\n}\n\n.message {\n  align-items: center;\n  display: flex;\n  gap: 8px;\n  justify-content: space-between;\n}\n\n.message-text {\n  font: var(--font-body-5);\n  letter-spacing: var(--font-spacing-body-5);\n}\n\n.left .message-text {\n  color: var(--incoming-bubble-text-primary);\n  max-width: 276px;\n}\n\n.right .message-text {\n  color: var(--outgoing-bubble-text);\n}\n\n.message-status {\n  align-items: center;\n  color: var(--base-80);\n  font: var(--font-caption-1);\n  letter-spacing: var(--font-spacing-caption-1);\n  display: flex;\n  gap: 8px;\n  margin-inline-start: 8px;\n}\n\n.message-bubble:not(.short-bubble) .message-status {\n  align-self: flex-end;\n  margin-top: -16px;\n}\n\n.left .message-status {\n  color: var(--outgoing-bubble-text_70);\n}\n\n.right .message-status {\n  color: var(--incoming-bubble-text-secondary);\n}\n\n.status-icon {\n  fill: var(--outgoing-bubble-primary);\n}\n\n.audio-message {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.audio-histogram {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n}\n\n.histogram-image {\n  width: 188px;\n  height: 24px;\n}\n\n.audio-duration {\n  color: var(--outgoing-bubble-text_70);\n  font: var(--font-subtitle-4);\n  letter-spacing: var(--font-spacing-subtitle-4);\n  margin-top: 2px;\n}\n\n.play-icon {\n  --file-ic-primary-color: var(--outgoing-bubble-primary);\n  --file-ic-secondary-color: var(--outgoing-bubble-on-primary);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `AppearanceExample__container-f5f470`,
	"content": `AppearanceExample__content-e32c7e`,
	"message-bubble": `AppearanceExample__message-bubble-ac8f5b`,
	"messageBubble": `AppearanceExample__message-bubble-ac8f5b`,
	"short-bubble": `AppearanceExample__short-bubble-fff339`,
	"shortBubble": `AppearanceExample__short-bubble-fff339`,
	"left": `AppearanceExample__left-ac57b9`,
	"right": `AppearanceExample__right-dad1c8`,
	"message-reply": `AppearanceExample__message-reply-c2c20d`,
	"messageReply": `AppearanceExample__message-reply-c2c20d`,
	"reply-name": `AppearanceExample__reply-name-e5c33c`,
	"replyName": `AppearanceExample__reply-name-e5c33c`,
	"reply-text": `AppearanceExample__reply-text-d3dc72`,
	"replyText": `AppearanceExample__reply-text-d3dc72`,
	"message": `AppearanceExample__message-a7e13b`,
	"message-text": `AppearanceExample__message-text-abbbdf`,
	"messageText": `AppearanceExample__message-text-abbbdf`,
	"message-status": `AppearanceExample__message-status-c37ee6`,
	"messageStatus": `AppearanceExample__message-status-c37ee6`,
	"status-icon": `AppearanceExample__status-icon-e4ad88`,
	"statusIcon": `AppearanceExample__status-icon-e4ad88`,
	"audio-message": `AppearanceExample__audio-message-cc966d`,
	"audioMessage": `AppearanceExample__audio-message-cc966d`,
	"audio-histogram": `AppearanceExample__audio-histogram-d22935`,
	"audioHistogram": `AppearanceExample__audio-histogram-d22935`,
	"histogram-image": `AppearanceExample__histogram-image-ce0a85`,
	"histogramImage": `AppearanceExample__histogram-image-ce0a85`,
	"audio-duration": `AppearanceExample__audio-duration-e75613`,
	"audioDuration": `AppearanceExample__audio-duration-e75613`,
	"play-icon": `AppearanceExample__play-icon-cd292e`,
	"playIcon": `AppearanceExample__play-icon-cd292e`
};
module.exports = ___CSS_LOADER_EXPORT___;
